import {POPUP_SETTINGS} from '@/models/POPUP_SETTINGS';
import {DASHBOARD_OPTIONS} from '@/models/DASHBOARD_OPTIONS';

export default function(){
	
	const RESTRICTIONS_MAPPING  = {
		canEditMap: { name: 'can_edit_map', option: null},
		canEditContentForm: { name: 'can_edit_popups', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].CONTENT_FORM.VALUE},
		canEmbedMap: { name: 'can_embed_map', option: POPUP_SETTINGS.WEB.SECTIONS[1].EMBED_CODE.VALUE},
		canHavePublicMaps: { name: 'can_have_public_maps', option: null},
		canHavePrivateMaps: { name: 'can_have_private_maps', option: null},
		canSelectDesignTemplates: { name: 'can_select_design_templates', option: null},
		hasAnalytics: { name: 'has_analytics', option: POPUP_SETTINGS.CLIENT.SECTIONS[0].ANALYTICS.VALUE},
		hasAssetManagement: { name: 'has_asset_management', option: POPUP_SETTINGS.CONTENT.SECTIONS[1].MANAGE_ASSETS.VALUE},
		hasCname: { name: 'has_cname', option: null},
		hasCustomDesign: { name: 'has_custom_design', option: null},
		hasDesignTemplates: { name: 'has_design_templates', option: null},
		hasEditorial: { name: 'has_editorial', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].EDITOR_NOTE.VALUE},
		hasGlobalDesign: { name: 'has_global_design', option: DASHBOARD_OPTIONS.CREATE.GROUPS[1].GLOBAL_SETTINGS.VALUE},
		hasGlossary: { name: 'has_glossary', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].GLOSSARY.VALUE},
		hasMapHeader: { name: 'has_map_header', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].HEADER_BAR.VALUE},
		hasMediaTemplates: { name: 'has_media_templates', option: POPUP_SETTINGS.CONTENT.SECTIONS[1].MEDIA_TEMPLATES.VALUE},
		hasMeteredMaps: { name: 'has_metered_maps', option: null},
		hasReferences: { name: 'has_references', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].LIST_REFERENCES.VALUE},
		hasSeo: { name: 'has_seo', option: POPUP_SETTINGS.WEB.SECTIONS[0].SEO_SETTINGS.VALUE},
		hasSocialLinks: { name: 'has_social_network_sharing', option: POPUP_SETTINGS.WEB.SECTIONS[0].SOCIAL_NETWORKS.VALUE},
		hasSubdomains: { name: 'has_subdomain', option: null},
		hasTemplates: { name: 'has_templates', option: POPUP_SETTINGS.TEMPLATES.SECTIONS[2].OWN_TEMPLATES.VALUE},
		hasQuizzes: {name: 'has_quizzes', option: POPUP_SETTINGS.CONTENT.SECTIONS[0].QUIZ.VALUE},
		hasExternalContentProviders: {name: 'external_content_providers', option: POPUP_SETTINGS.CLIENT.SECTIONS[0].MANAGE_API.VALUE},
		hasCustomLoginPage: {name: 'has_custom_login_page', option: null}
	}
	
	function _convertFromOriginal(prop, value){
		for(const [key, specs] of Object.entries(RESTRICTIONS_MAPPING)){
			if(specs.name === prop) {
				const result = Object.assign({}, specs, {value})
				return {[key]: result}
			}
		}
	}
	
	function getRestrictions(features){
		const restrictions = {};
		for( const [key, value] of Object.entries(features)){
			const result = _convertFromOriginal(key, value);
			if(result) {
				Object.assign(restrictions, result);
			}
		}
		return restrictions
	}
	
	return {
		getRestrictions,
	}
}
